import angular from 'angular';
import services from './services/services';
import components from './components/components';
import modals from './modals/modals';
import moment from 'moment';
import './timesheet.css';
import timesheetComponent from "./timesheet.component";

let timesheetModule = angular.module('timesheet', [
  services.name, modals.name,components.name,
])
  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    // $stateProvider
    //   .state('timesheet', {
    //     url: '/timesheet',
    //     template: '<timesheet></timesheet>',
    //     data: {
    //       pageHeader: false,
    //       pageTitle: 'Timesheet',
    //       pageDesc: ''
    //     }
    //   });

  })
.filter('dateRangeFilter', () => {
  return (dates) => {
    dates[0] = dates[0] || moment().startOf('month');
    dates[1] = dates[1] || moment();

    let start = dates[0],
      end = dates[1];

    if (start.month() == end.month()) {
      return start.format("MMM D") + " - " + end.format("D");
    } else {
      return start.format("MMM D") + " - " + end.format("MMM D");
    }
  }
})
.component('timesheet', timesheetComponent);

export default timesheetModule;



// WEBPACK FOOTER //
// ./client/pages/timesheet/timesheet.js